module.exports = __webpack_public_path__ + "static/img/33.597d7e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/33.png
// module id = TVZw
// module chunks = 1